import { render, staticRenderFns } from "./phoneView.vue?vue&type=template&id=2e4bee80&scoped=true&"
import script from "./phoneView.vue?vue&type=script&lang=js&"
export * from "./phoneView.vue?vue&type=script&lang=js&"
import style0 from "./phoneView.vue?vue&type=style&index=0&id=2e4bee80&scoped=true&lang=css&"
import style1 from "./phoneView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bee80",
  null
  
)

export default component.exports